import { render, staticRenderFns } from "./RemoteProgramasTemp.vue?vue&type=template&id=5132854a&"
import script from "./RemoteProgramasTemp.vue?vue&type=script&lang=js&"
export * from "./RemoteProgramasTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports